module.exports = __webpack_public_path__ + "static/media/web-app.2da13df2.png";